import React, { useCallback, useEffect, useState } from "react";
// import { useParams } from 'react-router'
import { useSelector } from "react-redux";
import { PDFDownloadLink } from "@react-pdf/renderer";

import { CircularProgress } from "@mui/material";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

import moment from "moment";
import "moment/locale/es";

import NumberFormat from "react-number-format";

import "./vistaPrevia.css";
// import { fetchConToken, fetchConTokenFile } from '../../../helpers/fetch'
// import { ModalProgress } from '../../modals/ModalProgress'
import { PdfFile } from "./PdfFile";

// import imgRejilla from './rejilla.svg'
import { VistaPreviaPrint } from "./VistaPreviaPrint";

const VistaPrevia = ({ open, setOpen, dataPreview }) => {
  // console.log('--dataPreview--', dataPreview)

  const auth = useSelector((state) => state.auth);
  const infoEmp = useSelector((state) => state.general.info);

  const { listaTiposDocumentos, listaFormasPagos } = useSelector(
    (state) => state.general,
  );
  const { url_foto } = infoEmp;

  const progress = false;

  // const [progress, setProgress] = useState(false)
  const [openPrint, setOpenPrint] = useState(false);
  const [docName, setDocName] = useState("");
  const [payFormsName, setPayFormsName] = useState("");
  // const [openPreviewOptions, setOpenPreviewOptions] = useState(false)
  // const [viewOptions, setViewOptions] = useState({
  //     ocultar_montos_items: false,
  //     ver_solo_subtotal_item: false,
  //     ver_solo_titulos: false,
  //     ver_total_con_impuestos: false
  // })

  const viewOptions = useState({
    ocultar_montos_items: false,
    ver_solo_subtotal_item: false,
    ver_solo_titulos: false,
    ver_total_con_impuestos: false,
  });

  // const [paymentStatus, setPaymentStatus] = useState(dataPreview.statusPaymentsByProjects || null)
  const paymentStatus = dataPreview.statusPaymentsByProjects || null;

  // const params = useParams()
  const {
    separacion_miles,
    separacion_decimales,
    simbolo,
    subtotal,
    descuento,
    monto_base,
    observaciones,
    total_factura,
    total_impuesto,
    impuesto_porcentaje,
    descuento_porcentaje,
  } = dataPreview;

  const handleClose = () => {
    setOpen(false);
  };

  const descriptionElementRef = React.useRef(null);
  const { current: descriptionElement } = descriptionElementRef;

  const getNames = useCallback(() => {
    const foundDocName = listaTiposDocumentos.find(
      (t) => parseInt(t.id) === parseInt(dataPreview?.id_tipo_documento),
    );

    if (foundDocName) {
      let newName = foundDocName.nombre;
      if (newName === "Factura 18%") {
        newName = "FACTURA";
      }

      if (newName === "Boleta de venta 18%") {
        newName = "BOLETA DE VENTA";
      }

      setDocName(newName);
    }

    const foundPayForms = listaFormasPagos.find(
      (t) => parseInt(t.id) === parseInt(dataPreview?.id_forma_pago),
    );
    if (foundPayForms) {
      setPayFormsName(foundPayForms.nombre);
    }
  }, [
    dataPreview?.id_tipo_documento,
    dataPreview?.id_forma_pago,
    listaFormasPagos,
    listaTiposDocumentos,
  ]);

  const handleDowload = async () => {
    document.getElementById(`btn-descargar-pdf`).click();
  };

  const handlePrint = async () => {
    setOpenPrint(true);
  };

  useEffect(() => {
    getNames();

    if (open) {
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open, descriptionElement, getNames]);

  return (
    <div>
      <Dialog
        className="ContainerModalVistaPrevia"
        open={open}
        onClose={handleClose}
        scroll={"paper"}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle className="ColorTitleDocument" id="scroll-dialog-title">
          <div>
            <label>Vista previa</label>
          </div>

          <IconButton
            aria-label="close"
            style={{ padding: "0", float: "right" }}
            onClick={() => setOpen(false)}
          >
            <CloseIcon style={{ color: "#78667E" }} />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers className="DialogContentVistaPrevia">
          {/* {(estado_validacion === 'por validar' || estado_validacion === 'requiere' || estado_validacion === 'solicitado') &&
                        < div className='copia-no-valida'>
                            <h2>Copia no válida</h2>
                            <h3>( compra pendiente de validar )</h3>
                        </div>
                    } */}

          <div className="ContainerPresupuesto">
            <section className="Section1Presupuesto">
              <section>
                <div>
                  <div>
                    <h1 className="ColorPrimary TitleModal uppercase">
                      {docName || "comprobante"}
                    </h1>
                    <p className="SubTitle ColorTitleDocument ">{`#0000${dataPreview.numero}`}</p>
                  </div>
                  <section className="ContainerLogoEmpresa">
                    <img
                      className="LogoEmpresa"
                      src={url_foto}
                      alt="Logo empresa"
                      style={{ marginRight: 20 }}
                    />
                  </section>
                </div>

                <p className="SubTitle ColorTitleDocument ">
                  {moment(dataPreview?.fecha_emision).format("DD MMMM YYYY")}
                </p>
                <section className="InfoGeneralPpto">
                  <div>
                    <p>Cliente: </p>
                    <p style={{ textTransform: "uppercase" }}>
                      {dataPreview?.cliente || "N/A"}
                    </p>
                  </div>

                  {dataPreview?.ruc && (
                    <div>
                      <p>RUC: </p>
                      <p style={{ textTransform: "uppercase" }}>
                        {dataPreview?.ruc || "N/A"}
                      </p>
                    </div>
                  )}

                  <div className="mt-2">
                    <span
                      className={`
                                                 rounded p-1 uppercase text-[11px] font-bold
                                                ${dataPreview.estado === "pagada" ? "bg-green-300 text-green-800" : "bg-blue-200 text-[#5B7DF8]"}
                                                
                                            `}
                    >
                      {dataPreview.estado !== "pagada"
                        ? "Pendiente"
                        : dataPreview.estado}
                    </span>
                  </div>

                  {/* <div>
                                        <p>Enviado por: </p>
                                        <p style={{ textTransform: 'uppercase' }}>{`${auth.name || 'Nombre'} / ${auth.email || 'N/A'}`}</p>
                                    </div> */}
                </section>
              </section>
            </section>

            <section className="Section2Presupuesto">
              <section>
                <h1 className="ColorTitleDocument TitleSection2 Uppercase">
                  {dataPreview.referencia}
                </h1>
                <section className="InfoGeneralPpto">
                  <TablaItems
                    dataPreview={dataPreview}
                    viewOptions={viewOptions}
                  />

                  <section className="row InfoFinalPpto">
                    <div className="col-7"></div>
                    <div className="col-5 p-bloque-total">
                      {descuento > 0 && (
                        <div className="row">
                          <div className="col-6">
                            <label className="p-label-total">SUBTOTAL</label>
                          </div>
                          <div className="col-6">
                            <NumberFormat
                              className="p-label-total-monto"
                              value={subtotal}
                              displayType={"text"}
                              thousandSeparator={separacion_miles}
                              decimalSeparator={separacion_decimales}
                              prefix={`${simbolo} `}
                            />
                          </div>
                        </div>
                      )}

                      {descuento > 0 && (
                        <div className="row">
                          <div className="col-6">
                            <label className="p-label-total">
                              ( {descuento_porcentaje}% )
                              <span className="ms-2">DESC</span>
                            </label>
                          </div>
                          <div className="col-6">
                            <NumberFormat
                              className="p-label-total-monto"
                              value={descuento}
                              displayType={"text"}
                              thousandSeparator={separacion_miles}
                              decimalSeparator={separacion_decimales}
                              prefix={`${simbolo} `}
                            />
                          </div>
                        </div>
                      )}

                      {parseFloat(impuesto_porcentaje) > 0 && (
                        <div className="row">
                          <div className="col-6">
                            <label className="p-label-total">TOTAL BASE</label>
                          </div>
                          <div className="col-6">
                            <NumberFormat
                              className="p-label-total-monto"
                              value={monto_base}
                              displayType={"text"}
                              thousandSeparator={separacion_miles}
                              decimalSeparator={separacion_decimales}
                              prefix={`${simbolo} `}
                            />
                          </div>
                        </div>
                      )}

                      {parseFloat(impuesto_porcentaje) > 0 && (
                        <div className="row">
                          <div className="col-6">
                            <label className="p-label-total">
                              ( {parseFloat(impuesto_porcentaje).toFixed(0)}% )
                              <span className="ms-2">IGV</span>
                            </label>
                          </div>
                          <div className="col-6">
                            <NumberFormat
                              className="p-label-total-monto"
                              value={total_impuesto}
                              displayType={"text"}
                              thousandSeparator={separacion_miles}
                              decimalSeparator={separacion_decimales}
                              prefix={`${simbolo} `}
                            />
                          </div>
                        </div>
                      )}

                      <div className="row">
                        <div className="col-6">
                          <label className="p-label-total">TOTAL</label>
                        </div>
                        <div className="col-6">
                          <NumberFormat
                            className="p-label-total-monto"
                            value={total_factura}
                            displayType={"text"}
                            thousandSeparator={separacion_miles}
                            decimalSeparator={separacion_decimales}
                            prefix={`${simbolo} `}
                          />
                        </div>
                      </div>
                    </div>
                  </section>
                </section>
              </section>
            </section>

            <section className="Section3Presupuesto">
              <h1 className="ColorTitleDocument TitleSection2 TitleSection3">
                Condiciones
              </h1>
              <section>
                <div className="ObservacionesPpto">
                  <div>
                    <p>Forma de pago: </p>
                    <p style={{ textTransform: "uppercase" }}>
                      {payFormsName || ""}
                    </p>
                  </div>

                  {observaciones && (
                    <div>
                      <p>Observaciones: </p>
                      <p style={{ textTransform: "uppercase" }}>
                        {observaciones || ""}
                      </p>
                    </div>
                  )}
                </div>
              </section>
            </section>

            <section className="mt-4">
              <h1 className="ColorTitleDocument TitleSection2 TitleSection3">
                Estado de Cobro del Recibo
              </h1>
              <StatusCobrosRecibo
                paymentStatus={paymentStatus}
                dataPreview={dataPreview}
                viewOptions={viewOptions}
              />
            </section>

            <section className="mt-4">
              <h1 className="ColorTitleDocument TitleSection2 TitleSection3">
                Estado de Cobros del Proyecto
              </h1>
              {paymentStatus?.payments?.length > 0 ? (
                <StatusCobros
                  paymentStatus={paymentStatus}
                  dataPreview={dataPreview}
                  viewOptions={viewOptions}
                />
              ) : (
                <h3 className="mt-2 text-gray-600">
                  No hay cobros registrados.
                </h3>
              )}
            </section>

            <section className="Section4Presupuesto mt-4">
              <h1 className="mt-5 text-[13px] font-bold">
                ** Copia no válida para efectos tributarios.
              </h1>
            </section>
          </div>
        </DialogContent>

        <DialogActions className="DialogActionVistaPrevia">
          <Button
            className="p-btn-secondary"
            variant="contained"
            size="medium"
            type="button"
            onClick={handleDowload}
          >
            Descargar
            {progress && <CircularProgress className="CircularProgress" />}
          </Button>

          <Button
            className="p-btn-primary"
            variant="contained"
            size="medium"
            type="button"
            onClick={handlePrint}
          >
            Imprimir
          </Button>
        </DialogActions>

        {openPrint && (
          <VistaPreviaPrint
            auth={auth}
            infoEmp={infoEmp}
            dataPreview={{
              ...dataPreview,
              payFormsName: payFormsName,
              docName: docName,
            }}
            viewOptions={viewOptions}
            open={openPrint}
            setOpen={setOpenPrint}
            urlLogo={url_foto}
            paymentStatus={paymentStatus}
          />
        )}

        <div style={{ display: "none" }}>
          <PDFDownloadLink
            document={
              <PdfFile
                auth={auth}
                infoEmp={infoEmp}
                dataPreview={{
                  ...dataPreview,
                  payFormsName: payFormsName,
                  docName: docName,
                }}
                viewOptions={viewOptions}
                urlLogo={url_foto}
                paymentStatus={paymentStatus}
              />
            }
            fileName={`${docName}${"_"}${dataPreview.numero}_.pdf`}
          >
            <button id="btn-descargar-pdf" type="button">
              descargar
            </button>
          </PDFDownloadLink>
        </div>
      </Dialog>
    </div>
  );
};

export default VistaPrevia;

const TablaItems = ({ dataPreview, viewOptions }) => {
  const { separacion_miles, separacion_decimales, simbolo } = dataPreview;

  return (
    <table className="table table-vista-previa">
      <thead>
        <tr className="text-center">
          <th scope="col" className="text-start">
            Ítems
          </th>
          <th scope="col">Cant.</th>
          <th scope="col" className="text-end">
            P. Unitario
          </th>
          <th scope="col" className="text-end">
            Subtotal
          </th>
        </tr>
      </thead>
      <tbody>
        {dataPreview?.items?.map((it) => {
          return (
            <tr className="text-center title" key={it.id}>
              <td className="text-start">{it.nombre}</td>
              <td>{it.cantidad}</td>
              <td className="text-end">
                <NumberFormat
                  value={it.precio_unitario || 0}
                  displayType={"text"}
                  thousandSeparator={separacion_miles}
                  decimalSeparator={separacion_decimales}
                  prefix={`${simbolo} `}
                />
              </td>
              <td className="text-end">
                <NumberFormat
                  value={it.subtotal || 0}
                  displayType={"text"}
                  thousandSeparator={separacion_miles}
                  decimalSeparator={separacion_decimales}
                  prefix={`${simbolo} `}
                />
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

const StatusCobrosRecibo = ({ paymentStatus, dataPreview, viewOptions }) => {
  const {
    separacion_miles,
    separacion_decimales,
    simbolo,
    total_factura,
    total_cobrado,
    total_por_cobrar,
  } = dataPreview;

  return (
    <div>
      <section className="p-2">
        <div className="flex justify-between mt-2">
          <div>
            <p>Total Facturado</p>
            <p>
              <NumberFormat
                value={total_factura || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                prefix={`${simbolo} `}
              />
            </p>
          </div>
          <div>
            <p>Total Abonado</p>
            <p className="font-bold">
              <NumberFormat
                value={total_cobrado || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                prefix={`${simbolo} `}
              />
            </p>
          </div>
          <div>
            <p>Saldo</p>
            <p>
              <NumberFormat
                value={total_por_cobrar || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                prefix={`${simbolo} `}
              />
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

const StatusCobros = ({ paymentStatus, dataPreview, viewOptions }) => {
  const { separacion_miles, separacion_decimales, simbolo } = dataPreview;
  const { total_budget, total_payments, total_balance, payments } =
    paymentStatus;

  return (
    <div>
      <section className="p-2">
        <div className="flex justify-between mt-2">
          <div>
            <p>Presupuesto Aprobado</p>
            <p>
              <NumberFormat
                value={total_budget || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                prefix={`${simbolo} `}
              />
            </p>
          </div>
          <div>
            <p>Total Abonado</p>
            <p className="font-bold">
              <NumberFormat
                value={total_payments || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                prefix={`${simbolo} `}
              />
            </p>
          </div>
          <div>
            <p>Saldo</p>
            <p>
              <NumberFormat
                value={total_balance || 0}
                displayType={"text"}
                thousandSeparator={separacion_miles}
                decimalSeparator={separacion_decimales}
                prefix={`${simbolo} `}
              />
            </p>
          </div>
        </div>
      </section>

      <div className="p-2">
        <table className="table mt-2">
          <thead>
            <tr className="text-center border-b-2 border-gray-300">
              <th className="text-start">Fecha cobro</th>
              <th className="text-center">Documento</th>
              <th className="text-center">Ítem / Concepto</th>
              <th className="text-end">Monto</th>
              <th className="text-center">Estado</th>
            </tr>
          </thead>
          <tbody>
            {payments?.map((it) => {
              return (
                <tr className="text-center title" key={it.id}>
                  <td className="text-start">
                    {moment(it.date).format("DD-MM-YYYY")}
                  </td>
                  <td>{`${it.invoice_ref} / ${it.invoice_nro}` || "---"}</td>
                  <td className="capitalize">{it.concept || "---"}</td>
                  <td className="text-end">
                    <NumberFormat
                      value={it.amount || 0}
                      displayType={"text"}
                      thousandSeparator={separacion_miles}
                      decimalSeparator={separacion_decimales}
                      prefix={`${simbolo} `}
                    />
                  </td>
                  <td className="text-center text-green-600 capitalize">
                    {it.state}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
